import { React, useState } from "react";
import {
  Row,
  Col,
  Layout,
  Typography,
  Tooltip,
  Button,
  Popover,
} from "antd/lib";
import { HomeOutlined } from "@ant-design/icons";
import { ReactComponent as SmasiPictureMark } from "./../Assets/smartsignals_Picturemark.svg";
// import { ReactComponent as ClientLogo } from "./../Assets/cm_logo.svg";
import MenuToggle from "./MenuToggle";
// import UserMenu from "./UserMenu.js";
import { useLocation } from "react-router-dom";
const client = window.location.host.startsWith("vw.") ? "vw" : "cm";
const { Header } = Layout;
const { Text } = Typography;

const HeaderComponent = ({ collectionsList }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const location = useLocation();
  return (
    <Header style={{ height: "74px", padding: 0, background: "#000000" }}>
      <Row align="middle">
        <Col flex="20px">
          <MenuToggle
            bannerTitle=""
            drawerTitle="Menu"
            allCollections={collectionsList}
          />
        </Col>
        {location.pathname !== "/" && (
          <Col flex="40px">
            {/* <UserMenu /> */}
            <Tooltip title="Home">
              <Button
                type="text"
                style={{ marginLeft: "0.4rem" }}
                href="/"
                icon={
                  <HomeOutlined
                    style={{
                      fontSize: "1.6rem",
                      color: "#F7FAF2",
                      padding: "0.5rem 1.5rem",
                    }}
                  ></HomeOutlined>
                }
                ghost
              />
              <Popover
                overlayInnerStyle={{
                  fontFamily: `${client}Regular`,
                }}
                content={
                  <p>
                    The home button will return you to the Daily Run - Results
                    Overview page.
                  </p>
                }
                // title="Popover Title"
                trigger="click"
                placement="bottomRight"
                overlayStyle={{
                  maxWidth: 600,
                }}
                overlayClassName="tutorialPopover"
                open={popoverVisible}
                onOpenChange={(visible) => setPopoverVisible(visible)}
              />
            </Tooltip>
          </Col>
        )}

        <Col flex="auto" style={{ textAlign: "end", marginTop: "10px" }}>
          <SmasiPictureMark width={"28px"} style={{}} />
          <Text
            strong
            style={{
              fontFamily: "cmBold",
              fontSize: "1.6rem",
              color: "#fff",
              margin: "0 0.8rem",
            }}
          >
            Smart QA Auditor.
          </Text>
        </Col>
        {/* <Col flex="auto" style={{ textAlign: "end" }}></Col> */}

        {/* <Col flex="190px" style={{ alignItems: "flex-end" }}>
          <ClientLogo
            style={{
              marginTop: "12px",
            }}
          />
        </Col> */}
      </Row>
    </Header>
  );
};

export default HeaderComponent;
